import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const AccessGuard = ({ children }) => {
    const { pathname } = useLocation();
    const [blocked, setBlocked] = useState(false);

    useEffect(() => {
        let cancelled = false;
        fetch(`${API_BASE_URL}/public/access-check`, { headers: { Accept: 'application/json' } })
            .then(async (res) => {
                if (res.status !== 403) return;
                const data = await res.json().catch(() => ({}));
                if (!cancelled && data.blocked) setBlocked(true);
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, []);

    if (blocked && !pathname.startsWith('/admin')) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f9fafb',
                padding: 24,
                textAlign: 'center',
            }}>
                <div>
                    <i className="ph ph-prohibit" style={{ fontSize: 64, color: '#dc2626' }}></i>
                    <h1 style={{ fontSize: 28, margin: '16px 0 8px' }}>Accès refusé</h1>
                    <p style={{ color: '#6b7280' }}>Votre accès à ce site a été bloqué.</p>
                </div>
            </div>
        );
    }

    return children;
};

export default AccessGuard;
